import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, allowedRoles, denyLapangan }) => {
  const { isAuthenticated, user, loading } = useAuthStore();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />; // Atau halaman 'akses ditolak'
  }
  
  if (denyLapangan && user?.jabatan === 'LAPANGAN') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
